<template>
  <v-app id="inspire">
    <v-container fluid id="mainFrame">
      <InfoDialog ref="infoDialog" />
      <v-row>
        <v-col class="text-left" style="max-width: fit-content;">
          <IconTooltipButtonBottom
              @click="$router.push('/management')"
              icon="mdi-arrow-left"
              tooltip="Zurück"
              large
          />
        </v-col>
        <v-col style="align-self: center">
          <h3>Mandantenverwaltung</h3>
        </v-col>
      <v-col class="text-right">
        <v-btn color="primary" @click="addClient()" elevation="0">
          <v-icon color="#F5F5F5" medium>add</v-icon > Neuer Mandant
        </v-btn>
      </v-col>
      </v-row>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Mandanten ID</th>
              <th class="text-left">Mandantenname</th>
              <th class="text-left">Mandantenkürzel</th>
              <th class="text-left">Administrator-Email</th>
              <th class="text-left">Status</th>
              <th class="text-left">Identitätsfarbe</th>
              <th class="text-left">Logo</th>
              <th class="text-center">Aktionen</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="client in clients" :key="client.id">
              <!-- <td><v-icon color="primary" @click="deleteRole(role.id)">mdi-delete-outline</v-icon>
              </td> -->
              <td class="cursor-default">{{ client.id }}</td>
              <td class="cursor-default">{{ client.companyName }}</td>
              <td class="cursor-default">{{ client.shortName }}</td>
              <td class="cursor-default">{{ client.adminEmail }}</td>
              <td :style="'font-weight:600;color:'+(client.activeState ? 'var(--green-color)':'var(--red-color)')"
                  class="cursor-default">{{
                  decodeActiveState(client.activeState) }}</td>
              <td
                  class="d-flex justify-center align-center"><v-avatar size="32"
                                              :style="'background-color:#'+client.identityColor"></v-avatar></td>
              <td>
                <img style="max-height:50px; max-width:100px;" :src="client.imageUrl" alt="Company logo" />
              </td>
              <td class="text-center" >
                <v-btn color="tr_red" text @click="changeClientActiveState(client)">
                  {{ client.activeState ? 'Deaktivieren' : 'Aktivieren' }}
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
    <AddClientDialog ref="addClientDialog" />
  </v-app>
</template>

<script>
import clientService from "@/components/clientService"
import InfoDialog from "@/components/common/InfoDialog";
import IconTooltipButtonBottom from "@/components/common/IconTooltipButtonBottom";
import AddClientDialog from './Dialogs/AddClientDialog.vue';
export default {
  name: "clientPanel",
  components:{
    InfoDialog,
    IconTooltipButtonBottom,
    AddClientDialog,
  },
  data() {
    return {
      clients: [],
      color:'#FF0000',
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    addClient(){
      this.$refs.addClientDialog
      .open()
      .then(() => {
        this.init();
      });
    },
    decodeActiveState(state){
      if(state){
        return "Aktiviert";
      }else{
        return "Deaktiviert"
      }
    },
    changeClientActiveState(client){
      let newState = true;
      if(client.activeState){
        newState = false;
      }
      clientService.changeClientActiveState({
        clientToChangeId: client.id,
        newActiveState: newState
      }).then(() => this.init())
    },
    deleteClient(clientId){
    },
    init() {
      clientService.retrieveClients().then((res) => this.clients = res.data);
    },
  },
};
</script>
<style scoped>
#mainFrame {
  overflow: visible;
}
th, td{
  vertical-align: middle;
}
.h3, h3{
  margin: 0;
}

</style>
